import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import {
    IPPVPurchaseGenerateOtpPayload,
    IPPVPurchaseGenerateOtpResponse,
} from '../../../entity/interface/iEntitlements';

export interface IPPVPurchaseGenerateOtpUseCase {
    execute(
        payload: IPPVPurchaseGenerateOtpPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchaseGenerateOtpResponse>;
}

export class PPVPurchaseGenerateOtpUseCase implements IPPVPurchaseGenerateOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get qitafGenerateOtpRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IPPVPurchaseGenerateOtpPayload,
        username: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string },
        apiKey: string
    ): Promise<IPPVPurchaseGenerateOtpResponse> {
        const response = await this.qitafGenerateOtpRepository.ppvPurchaseGenerateOtp(
            payload,
            username,
            authToken,
            authSign,
            identityToken,
            csrfToken,
            apiKey
        );
        return response;
    }
}
